import { toEncodedClientDetails } from '@peloton/analytics';
import { toNowTimezoneString } from '@peloton/time';
import { createWorkout } from '../generated';
import { spreadAnalytics } from './spreadAnalytics';
export var createWorkoutWithAnalytics = function createWorkoutWithAnalytics(api, analyticsProps, pelotonPlatform, createWorkoutRequest, acceptLanguage, options) {
  var encodedClientDetails = toEncodedClientDetails(spreadAnalytics(analyticsProps));
  return createWorkout(api, toNowTimezoneString(), createWorkoutRequest, pelotonPlatform, encodedClientDetails, acceptLanguage, options);
};